//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import BackendServices from "@/services/backend-services";
import moment from "moment";
import { required } from "@/utils/validations.js";
import { noValidation } from "@/utils/validations.js";

export default {
  name: "ProductTab",
  props: ["value"],
  components: {},
  mounted: function() {
    this.validateData();
    BackendServices.getSalesforceHierarchyLevelElements().then(response => {
      this.positionList = response.data;
    });
  },
  data: function() {
    return {
      moment,
      validForm: false,
      positionList: []
    };
  },
  methods: {
    required,
    noValidation,
    validateData: function() {
      this.$refs.form.validate().then(success => {
        if (success) {
          this.validForm = true;
          this.$emit("form-valid", this.validForm);
        } else {
          this.validForm = false;
          this.$emit("form-invalid", this.validForm);
        }
      });
    },
    updateData() {
      this.$emit("value", this.value);
    }
  }
};
